<div class="bg-white shadow rounded-lg p-6 mb-8 text-center mt-4">
    <h1 class="text-2xl font-bold mb-2">Liste de prédictions :</h1>
    <p-table [value]="projects()" [paginator]="true" [rows]="10" class="mt-4">
        <ng-template pTemplate="header">
            <tr>
                <th>ID</th>
                <th>Nom du projet</th>
                <th>Description du projet</th>
                <th>Actions</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-project>
            <tr>
                <td>{{ project.id }}</td>
                <td>{{ project.name }}</td>
                <td>{{ project.description }}</td>
                <td class="">
                    <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text"
                        (click)="editProject(project)"></button>
                    <button pButton icon="pi pi-trash" class="p-button-rounded p-button-text"
                        (click)="deleteProject(project.id, $event)"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-confirmdialog />
